import Vue from "vue";
import Auth from "@/lib/Auth";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "@/views/account/Login.vue";
import RegistroDispositivo from "@/views/account/RegistroDispositivo.vue";
import RecuperarSenha from "@/views/account/RecuperarSenha.vue";
import RedefinirSenha from "@/views/account/RedefinirSenha.vue";
import RedefinirPin from "@/views/account/ResetPIN.vue";
import CriarConta from "@/views/account/CriarConta.vue";
import PreCadastro from "@/views/account/PreCadastro.vue";

import GetAfiliado from "@/views/account/GetAfiliado.vue";
import Home from "@/views/Home.vue";
import Movimento from "@/views/financeiro/Movimento.vue";
import ComprovanteSaque from "@/views/comprovantes/Saques.vue";
import ComprovanteTranserencia from "@/views/comprovantes/Transferencias.vue";
import ComprovanteBoleto from "@/views/comprovantes/Boletos.vue";
import AdicionarSaldoTED from "@/views/financeiro/adicionarSaldoTED.vue";
import AdicionarSaldoBoleto from "@/views/financeiro/adicionarSaldoBoleto.vue";
import EncerrarConta from "@/views/account/EncerrarConta.vue";
import AdicionarSaldoPix from "@/views/financeiro/adicionarSaldoPix.vue";
import Transferencias from "@/views/financeiro/Transferencias.vue";
import TransferenciasPendentes from "@/views/financeiro/TransferenciasPendentes.vue";
import Afiliados from "@/views/Afiliados.vue";
import Saques from "@/views/financeiro/Saques.vue";
import Perfil from "@/views/profile/Perfil.vue";
import PerfilEditDadosBasicos from "@/views/profile/PerfilEditDadosBasicos.vue";
import PerfilEditDadosEndereco from "@/views/profile/PerfilEditDadosEndereco.vue";
import Documentacao from "@/views/profile/Documentos.vue";

import HomeDepositar from "@/views/financeiro/homeDepositar.vue";
import MeuQRcode from "@/views/financeiro/meuQrCode.vue";
import RelatorioPix from "@/views/financeiro/RelatorioPix.vue";
import RelatorioPixEnviados from "@/views/financeiro/RelatorioPixEnviados.vue";

import HomePix from "@/views/financeiro/homePix.vue";
import HomeServicos from "@/views/servicos/Servicos.vue";
import PagamentoContas from "@/views/servicos/PagamentoContas.vue";
import SegurancaHome from "@/views/seguranca/Seguranca.vue";
import PagarPIX from "@/views/public/PagarPix.vue";
import HomeIntegracoesV1 from "@/views/integracoes/IntegracoesV1.vue";
import HomeIntegracoesV2 from "@/views/integracoes/IntegracoesV2.vue";
import PixPendentes from "@/views/financeiro/PixPendentes.vue";
import ValidarEmail from "@/views/account/ValidarEmail.vue";

import CheckoutTransfer from "@/views/checkout/TransferenciaAPI.vue";
import Colaboradores from "@/views/Colaboradores.vue";
import TransferenciasPixChave from "@/views/financeiro/pix/TransferenciasPixChave.vue";
import HomeRelatorios from "@/views/financeiro/homeRelatorios.vue";
import ResumoMovimentacao from "@/views/financeiro/ResumoMovimentacao.vue";
import ResumoAnual from "@/views/financeiro/ResumoAnual.vue";
import HomeMenuPix from "@/views/financeiro/pix/homeMenuPix.vue";
import LerEMV from "@/views/financeiro/pix/LerEMV.vue";
import TransferirPixEMV from "@/views/financeiro/pix/TransferenciasPixEMV.vue";
import ComparativoPeriodo from "@/views/financeiro/reports/PixComparativoPeriodo.vue";

import Tst from "@/views/tst.vue";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/login",
    meta: {
      auth: false,
    },
    component: () => import("@/layouts/Login.vue"),
    children: [
      {
        path: "/login",
        alias: "/login/",
        component: Login,
        meta: {
          title: "Acesse sua conta",
        },
      },
      {
        path: "/validar-email/:id/",
        alias: "/validar-email/:id",
        component: ValidarEmail,
        meta: {
          title: "Validar E-mail",
        },
      },
      {
        path: "/conta/confirmacoes/email/:id/",
        alias: "/conta/confirmacoes/email/:id",
        component: ValidarEmail,
        meta: {
          title: "Validar E-mail",
        },
      },
      {
        path: "/device",
        alias: "/device/",
        component: RegistroDispositivo,
        meta: {
          title: "Autorização de dispositivo",
        },
      },
      {
        path: "/recuperar",
        alias: "/recuperar/",
        component: RecuperarSenha,
        meta: {
          title: "Recuperar Senha",
        },
      },
      {
        path: "/redefinir/:token",
        alias: "/redefinir/:token/",
        component: RedefinirSenha,
        meta: {
          title: "Redefinir Senha",
        },
      },
      {
        path: "/redefinir-pin/:token",
        alias: "/redefinir-pin/:token/",
        component: RedefinirPin,
        meta: {
          title: "Redefinir PIN",
        },
      },
      {
        path: "/registro/:id",
        alias: "/registro/:id/",
        component: CriarConta,
        meta: {
          title: "Abra sua conta",
        },
      },

      {
        path: "/cadastro",
        alias: "/cadastro/",
        component: PreCadastro,
        meta: {
          title: "Abra sua conta",
        },
      },
      {
        path: "/encerrar/:id",
        alias: "/encerrar/:id/",
        component: EncerrarConta,
        meta: {
          title: "Cancelamento de conta",
        },
      },
      /*{
        path: "/link/:id",
        alias: "/link/:id/",
        component: GetAfiliado,
        meta: {
          title: "Afiliado",
        },
       
      },
       */
    ],
  },
  {
    path: "/comprovantes",
    meta: {
      auth: false,
    },
    component: () => import("@/layouts/ComprovantesPrint.vue"),
    children: [
      {
        path: "/comprovantes/transferencia/:id",
        alias: "/comprovantes/transferencia/:id/",
        component: ComprovanteTranserencia,
        meta: {
          title: "Comprovante de Transferência",
        },
      },
      {
        path: "/comprovantes/saque/:id",
        alias: "/comprovantes/saque/:id/",
        component: ComprovanteSaque,
        meta: {
          title: "Comprovante de Retirada Bancária",
        },
      },
      {
        path: "/comprovantes/boleto/:id",
        alias: "/comprovantes/boleto/:id/",
        component: ComprovanteBoleto,
        meta: {
          title: "Comprovante de Pagamento",
        },
      },
    ],
  },
  {
    path: "/pagar",
    meta: {
      auth: false,
    },
    component: () => import("@/layouts/ComprovantesPrint.vue"),
    children: [
      {
        path: "/pagar/pix/:id",
        alias: "/pagar/pagar/:id/",
        component: PagarPIX,
        meta: {
          title: "Faça o pagamento do PIX",
        },
      },
    ],
  },
  {
    path: "/checkout",
    meta: {
      auth: false,
    },
    component: () => import("@/layouts/Checkout.vue"),
    children: [
      {
        path: "/checkout/pay/transfer/:id",
        alias: "/checkout/pay/transfer/:id/",
        component: CheckoutTransfer,
        meta: {
          title: "Checkout",
        },
      },
    ],
  },
  {
    path: "/",
    meta: {
      auth: true,
    },
    component: () => import("@/layouts/BaseApp.vue"),
    children: [
      {
        path: "",

        component: Home,
        meta: {
          title: "Resumo",
        },
      },
      {
        path: "/transferencias/interna",

        component: Transferencias,
        meta: {
          title: "Transferências",
        },
      },
      {
        path: "/transferencias/pendentes",

        component: TransferenciasPendentes,
        meta: {
          title: "Transferências Pendentes",
        },
      },
      {
        path: "/pix/pendentes",

        component: PixPendentes,
        meta: {
          title: "Pix Pendentes",
        },
      },

      /*  {
        path: "/saques",

        component: Saques,
        meta: {
          title: "Saques",
        },
      },*/
      {
        path: "/pix",

        component: HomePix,
        meta: {
          title: "Pix",
        },
      },
      {
        path: "/pix/meu-qr-code",

        component: MeuQRcode,
        meta: {
          title: "Meu QR Code",
        },
      },
      {
        path: "/pix/relatorios/emitidos",

        component: RelatorioPix,
        meta: {
          title: "Pix Recebidos",
        },
      },
      {
        path: "/pix/relatorios/enviados",

        component: RelatorioPixEnviados,
        meta: {
          title: "Pix Enviados",
        },
      },
      {
        path: "/pix/relatorios/comparativoPeriodo",

        component: ComparativoPeriodo,
        meta: {
          title: "Comparativo Período",
        },
      },

      {
        path: "/movimento",

        component: Movimento,
        meta: {
          title: "Movimentação",
        },
      },
      {
        path: "/carteira/adicionar/ted",

        component: AdicionarSaldoTED,
        meta: {
          title: "Adicionar",
        },
      },

      {
        path: "/carteira/adicionar/boleto",

        component: AdicionarSaldoBoleto,
        meta: {
          title: "Adicionar",
        },
      },
      {
        path: "/carteira/adicionar/pix",

        component: AdicionarSaldoPix,
        meta: {
          title: "Adicionar",
        },
      },
      {
        path: "/afiliados",

        component: Afiliados,
        meta: {
          title: "Afiliados",
        },
      },
      {
        path: "/carteira",

        component: HomeDepositar,
        meta: {
          title: "Depositar Dinheiro",
        },
      },

      {
        path: "/perfil",

        component: Perfil,
        meta: {
          title: "Perfil",
        },
      },

      {
        path: "/perfil/dados-basicos",

        component: PerfilEditDadosBasicos,
        meta: {
          title: "Perfil",
        },
      },
      {
        path: "/perfil/dados-endereco",

        component: PerfilEditDadosEndereco,
        meta: {
          title: "Perfil",
        },
      },

      {
        path: "/perfil/documentos",

        component: Documentacao,
        meta: {
          title: "Perfil",
        },
      },

      {
        path: "/servicos",

        component: HomeServicos,
        meta: {
          title: "Serviços",
        },
      },

      {
        path: "/pagamentos",

        component: PagamentoContas,
        meta: {
          title: "Pagamentos",
        },
      },

      {
        path: "/seguranca",

        component: SegurancaHome,
        meta: {
          title: "Segurança",
        },
      },

      {
        path: "/integracoes",

        component: HomeIntegracoesV2,
        meta: {
          title: "Integrações",
        },
      },
      {
        path: "/integracoes/v1",

        component: HomeIntegracoesV1,
        meta: {
          title: "Integrações",
        },
      },
      {
        path: "/colaboradores",

        component: Colaboradores,
        meta: {
          title: "Colaboradores",
        },
      },
      {
        path: "/pix/homePix",

        component: HomePix,
        meta: {
          title: "Faça um PIX",
        },
      },
      {
        path: "/pix/menuPix",

        component: HomeMenuPix,
        meta: {
          title: "Faça pagamento ou uma transferêncua via PIX",
        },
      },
      {
        path: "/pix/transferir/chave",

        component: TransferenciasPixChave,
        meta: {
          title: "Transferências Pix por chave",
        },
      },
      {
        path: "/pix/transferir/emv",

        component: LerEMV,
        meta: {
          title: "Pagar QR Code",
        },
      },
      {
        path: "/pix/transferir/emv/process",

        component: TransferirPixEMV,
        meta: {
          title: "Pagar QR Code",
        },
      },
      {
        path: "/relatorios",

        component: HomeRelatorios,
        meta: {
          title: "Relatórios",
        },
      },
      {
        path: "/relatorios/resumo",

        component: ResumoMovimentacao,
        meta: {
          title: "Resumo da movimentação",
        },
      },
      {
        path: "/relatorios/resumo/anual",

        component: ResumoAnual,
        meta: {
          title: "Resumo Anual",
        },
      },

      {
        path: "/tst",

        component: Tst,
        meta: {
          title: "Tst",
        },
      },
    ],
  },

  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0, behavior: "smooth" };
  },
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    if (!Auth.isLogged()) {
      next({ path: "/login" });
    } else {
      next();
    }
  } else {
    next();
  }
});
router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + " - " + process.env.VUE_APP_NAME;
  }
});

export default router;
